export const message = (msg = "", data = {}) => {
    console.log(msg, data)
}

export const error = (msg = "", data = {}) => {
    console.error(msg, data)
}